import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { ReviewsSection } from 'features/WhyWeFeedRaw/components/ReviewsSection'
import { ReviewsRoot } from './Reviews.styles'

type ReviewsOwnProps = ComponentProps<typeof ReviewsRoot>
export type ReviewsProps = ReviewsOwnProps & {}

const REVIEWS = [
  {
    name: 'why-we-feed-raw:reviews.1.name',
    message: 'why-we-feed-raw:reviews.1.message',
  },
  {
    name: 'why-we-feed-raw:reviews.2.name',
    message: 'why-we-feed-raw:reviews.2.message',
  },
  {
    name: 'why-we-feed-raw:reviews.3.name',
    message: 'why-we-feed-raw:reviews.3.message',
  },
]

export const Reviews = (_props: ReviewsProps) => {
  const { t } = useTranslation()

  const cta = t('why-we-feed-raw:cta-1')

  return (
    <ReviewsRoot>
      <ReviewsSection reviews={REVIEWS} cta={cta} />
    </ReviewsRoot>
  )
}

Reviews.displayName = 'Reviews'
